'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'ไม่สามารถใช้บริการได้ในขณะนี้ กรุณาลองอีกครั้งภายหลัง',
    NEED_ACTIVE: 'บัญชีของคุณ {{account}} กำลังใช้งานเว็บไซต์นี้เป็นครั้งแรก กรุณา {{activeLink}} เพื่อเปิดใช้งานให้เสร็จสมบูรณ์และกลับสู่หน้านี้เพื่อดำเนินการต่อ',
    GOTO_ACTIVE: 'เปิดใช้งานทันที',
    NOT_ACTIVED: 'บัญชียังไม่เปิดใช้งานให้เรียบร้อย กรุณา {{activeLink}} เพื่อทำการเปิดใช้งานให้เสร็จสมบูรณ์',
    COMPLETE_ACTIVE: 'ยืนยันการเปิดใช้งาน',
    FORBID_ACTIVE: 'บัญชีไม่รองรับใน AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'กรุณาเข้าสู่ระบบด้วยบัญชีอื่น',
    ACTIVE_PAGE: 'ไปที่หน้าการเปิดใช้งานบัญชี'
};